export default __webpack_public_path__ + "static/media/my_notifications_icon_active.28d85eb0.svg";